import { useState } from 'react';
import { Form, Input, Button, Typography } from 'antd';
import { useNavigate, Link } from 'react-router-dom';
import { localStorageSet } from '@/core/cookie';
import { post } from '@/core/request';
import './Login.less';

const { Title } = Typography;

export default function Login() {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const year = new Date().getFullYear();

    const onFinish = values => {
        values.modulesCode = '';
        setSubmitting(true);
        post('/enterprise/staffs/login', values)
            .then(res => {
                if (res.status_code === 200) {
                    if (localStorage.getItem('infos')) {
                        localStorage.removeItem('infos');
                    }

                    if (localStorage.getItem('roleList')) {
                        localStorage.removeItem('roleList');
                    }

                    localStorageSet('token', res.data.token);
                    localStorageSet('infos', JSON.stringify(res.data.staffsEntity));
                    localStorageSet('roleList', JSON.stringify(res.data.roleList));

                    const search = window.location.search;
                    const params = new URLSearchParams(search);
                    const returnUrl = params.get('returnurl') || '';

                    const url = returnUrl ? decodeURIComponent(returnUrl) : '/';
                    navigate(url);
                }
            })
            .finally(() => {
                setSubmitting(false);
            });
    };

    return (
        <div className="login-page login-centered">
            <div className="login-centered-card">
                <div className="login-centered-brand">
                    <div className="login-brand-logo">
                        <img src="/logo.svg" alt="华媒康讯" className="login-brand-logo-img" width={48} height={48} decoding="async" />
                    </div>
                    <div className="login-centered-titles">
                        <Title className="login-brand-title">华媒康讯•智管平台</Title>
                    </div>
                </div>

                <Form form={form} onFinish={onFinish} layout="vertical" size="large" className="login-form" requiredMark={false}>
                    <Form.Item name="userName" label="账号" className="login-form-item" rules={[{ required: true, message: '请输入手机号或邮箱地址' }]}>
                        <Input allowClear placeholder=" " autoComplete="username" prefix={<i className="bi bi-person login-input-icon" />} />
                    </Form.Item>

                    <Form.Item name="pwd" label="密码" className="login-form-item" rules={[{ required: true, message: '请输入密码' }]}>
                        <Input.Password allowClear placeholder=" " autoComplete="current-password" prefix={<i className="bi bi-lock login-input-icon" />} />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button type="primary" htmlType="submit" className="login-submit-btn" loading={submitting}>
                            登 录
                        </Button>
                    </Form.Item>

                    <div className="login-forgot-row">
                        <Link to="/forgetpassword" className="login-forgot-link">
                            忘记密码？
                        </Link>
                    </div>
                </Form>

                <div className="login-brand-badge">
                    <i class="bi bi-exclamation-circle"></i>
                    内部系统，请共同守护数据与业务安全
                </div>

                <div className="login-footer">&copy;{year} 北京华媒康讯 保留所有权利</div>
            </div>
        </div>
    );
}
